'use client';

import { CSSProperties, PropsWithChildren } from 'react';

import { useRouter } from 'next/navigation';

import { Cms_EditorNodeData } from '@lib/services/cms';
import { openInNewTab } from '@lib/utils';

interface EditorNestedLinkProps extends PropsWithChildren {
  data: Cms_EditorNodeData;
  style?: CSSProperties;
}

const EditorNestedLink: React.FC<EditorNestedLinkProps> = ({ data, children }) => {
  const element = data as Cms_EditorNodeData;
  const { push } = useRouter();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    const url = element._url || '/';

    if (element.data.openInNewTab) {
      openInNewTab(url);

      return;
    }

    if (element.data.type === 'INTERNAL') {
      push(url);

      return;
    }

    window.location.href = url;
  };

  return (
    <button className="ps-editor-link" type="button" onClick={handleClick}>
      {children}
    </button>
  );
};

export default EditorNestedLink;
